 $(function(){
    //AccorddionProductDetails
    $(".box-accordion .btn-link").click(function(){
        var target = $(this).attr("data-target");
    
        if ($(this).hasClass("collapsed")){
            $(target).stop().slideUp();
            $(this).removeClass("collapsed").addClass("collapse");
        } else {
            $(target).stop().slideDown();           
            $(this).removeClass("collapse").addClass("collapsed");
        }
    });
 });

function  clearButton() {
    $('input[name="q"]').keyup( function(e) {
        var tamanhoInput = $(this).val().length;       

        if(tamanhoInput >= 1) {
            $(".Search__Close").addClass("visible");
        } else {
            $(".Search__Close").removeClass("visible");
        }        
    });
}

var setSellerName = function(sellerName){    
    document.title = sellerName + ' - ' + document.title;
    $('.js-collection-name').html(sellerName);
}

var getSellerName = function(){
    const urlParam = new URLSearchParams(window.location.search),
        handleSeller = window.location.pathname.replace('/collections/all/','');
    if(urlParam.has('seller')){
        const sellerName = urlParam.get('seller');
        sessionStorage.setItem(handleSeller, sellerName);
        setSellerName(sellerName)
    }else if(sessionStorage.getItem(handleSeller)){
        setSellerName(sessionStorage.getItem(handleSeller))
    }
}

$(document).ready(function () {
    clearButton();
    getSellerName();
    // addDeliveryItemMenu();
    setExpressDateItems();
    if($('.money-mask')[0]){
        VMasker(document.querySelector(".money-mask")).maskMoney({
            unit: 'R$'
        })
    }
});

const addDeliveryItemMenu = () => {
//custom add menu entrega expressa tema remover quando adicionar ao menu
    $('.Header__MainNav .HorizontalList').append(`
    <li class="HorizontalList__Item ">
        <a href="javascript:;" class="Heading u-h6" onclick="openZipModal()">Entrega Expressa<span class="Header__LinkSpacer">Entrega Expressa</span></a>
    </li>
    `)
    $('.Drawer__Container .SidebarMenu__Nav').eq(0).append(`
    <div class="Collapsible"><a href="javascript:;" class="Collapsible__Button Heading Link Link--primary u-h6" onclick="openZipModal()">Entrega Expressa</a></div>
    `)

    //check in all-products without filter
    const currentUrl = window.location.href;

    if(
        (!sessionStorage.getItem('expressResult') && currentUrl.indexOf('/collections/all-products') > -1 && currentUrl.indexOf('/collections/all-products/products/') == -1)
        ||
        (sessionStorage.getItem('expressResult') && currentUrl.indexOf('/collections/all-products') > -1 && currentUrl.indexOf('/collections/all-products?pf_t_tag') == -1 && currentUrl.indexOf('/collections/all-products/products/') == -1)
    ){
        openZipModal();
        $('.CollectionMain').hide();
    }
}

const addToCartRedirect = () => {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    let formData = {
        'items': [{
         'id': $('form[action="/cart/add"] [name="id"]').val(),
         'quantity': $('form[action="/cart/add"] [name="quantity"]').val(),
         properties: {
            "tenant_id": $('form[action="/cart/add"] [name="properties[tenant_id]"]').val(),
            "product_id": $('form[action="/cart/add"] [name="properties[product_id]"]').val(),
            "product_client_code": $('form[action="/cart/add"] [name="properties[product_client_code]"]').val(),
            "seller_id": $('form[action="/cart/add"] [name="properties[seller_id]"]').val(),
            "seller_name": $('form[action="/cart/add"] [name="properties[seller_name]"]').val(),
            "warehouse_id": $('form[action="/cart/add"] [name="properties[warehouse_id]"]').val(),
            "seller_warehouse_name": $('form[action="/cart/add"] [name="properties[seller_warehouse_name]"]').val(),
            "diameter": $('form[action="/cart/add"] [name="properties[diameter]"]').val(),
            "height": $('form[action="/cart/add"] [name="properties[height]"]').val(),
            "length": $('form[action="/cart/add"] [name="properties[length]"]').val(),
            "width": $('form[action="/cart/add"] [name="properties[width]"]').val(),
            "variation_id": $('form[action="/cart/add"] [name="properties[variation_id]"]').val()
         }
         }]
       };
       
       fetch('/cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         document.dispatchEvent(new CustomEvent('theme:loading:end'));
         location.href="/cart"
       })
       .catch((error) => {
         console.error('Error:', error);
         document.dispatchEvent(new CustomEvent('theme:loading:end'));
       });
}

const setExpressDateItems = () => {
    let expressResult = sessionStorage.getItem('expressResult');
    if($('[data-express-tag]:not(".express-tag-loaded")')[0] && expressResult){
        expressResult = JSON.parse(expressResult);
        console.log('RESULT', expressResult)
        $('[data-express-tag]:not(".express-tag-loaded")').each((idx, item) => {
            debugger
            const currentTag = $(item).attr('data-express-tag');
            const resultItem = expressResult.find(x => { return x.tag == currentTag});
            if(resultItem){
                $(item).addClass('express-tag-loaded');
                const itemAdd = $(item).find('.ProductItem__Title')[0] ? $(item).find('.ProductItem__Title') : $(item).find('.ProductItem__LabelList');
                itemAdd.after(`<p class="delivery-express-time">Horário de Entrega: ${resultItem.initalDeliveryTime} até ${resultItem.finalDeliveryTime}</p>`)
            }
        })
    }
}

const openZipModal = () => {
    const { value: zipCode } = Swal.fire({
        title: 'Entrega Expressa',
        text: 'Digite seu CEP',
        input: 'text',
        showCancelButton: true,
        customClass: {
            container: 'modal-zip-express'
        },
        inputAttributes: {
            class: 'teste-classe'
        },
        inputValidator: (value) => {
            if(!value){
                return 'Digite um CEP válido'
            }
        },
        onOpen: (el) => {
            // console.log('tteste', $(el)[0])
            VMasker(document.querySelector('.swal2-input')).maskPattern('99999-999');
        }
    }).then((result) => {
        if(result.value){
            const zipCode = result.value.replace('-', '');    
            const msgErro = 'CEP não atendido ou horário de entrega expressa indisponível no momento!';
            Swal.showLoading()
            fetch(`${window.apiUrl}/ExpressDelivery/${zipCode}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                return response.json()
            })
            .then((result) => {
                // result = [
                //     {
                //         "Tag": "customExpressDelivery_e7a90ad7-ed18-4dc9-8b49-19a57bafffb8",
                //         "InitialCepRange": "000000001",
                //         "FinalCepRange": "999999999",
                //         "InitalDeliveryTime": "08:02",
                //         "FinalDeliveryTime": "18:02",
                //         "Price": "15.00"
                //     }
                // ]
                sessionStorage.setItem('currentCEP', zipCode);
                sessionStorage.setItem('expressResult', JSON.stringify(result));
                if(result.length > 0){
                    // https://www.adegaonline.com.br/collections/all-products?pf_t_tag=Tinto&pf_t_tag=Seller%3A+Sele%C3%A7%C3%A3o+Adega
                    const collectionUrl = '/collections/all-products?'
                    let paramsUrl = '';
                    $.each(result, (idx, item) => {
                        if(idx > 0){
                            paramsUrl += '&'
                        }
                        paramsUrl += `pf_t_tag=${item.tag}`
                    })
                    window.location.href=`${collectionUrl}${paramsUrl}`
                }else{
                    Swal.fire({
                        title: 'Desculpe!',
                        text: msgErro
                    })
                }
            })
            .catch((error) => {
                console.error('Error:', error);                
                Swal.fire({
                    title: 'Desculpe!',
                    text: msgErro
                })
                // Swal.hideLoading()
            });
        }
        // https://sc-hom-webapp-integration.azurewebsites.net/Shopify/tenants/b573540d-c8c9-4df9-87da-13910f645618/ExpressDelivery/04106061
    })
    // Swal.showLoading()
}

//! Métodos para a funcionalidade do calendário custozado do input tipo date_________________|  Ínicio |

$(document).on('click tap', '.keep-buying--js', function(){
    
    if(window.matchMedia("(max-width: 768px)").matches){
        $('#sidebar-cart').attr('aria-hidden', 'true');
        $('.PageOverlay').removeClass('is-visible'); 
        $('html').removeClass('no-scroll'); 

        document.documentElement.classList.remove('no-scroll');

        disableBodyScroll(false, '[data-scrollable]');
        

        // $('body').css('overflow', 'visible !important');
    } else{
        $('html').css('overflow', 'visible !important');    
        $('#sidebar-cart').attr('aria-hidden', 'true');
        $('.PageOverlay').removeClass('is-visible');    
        $('#sidebar-cart').removeAttr('tabindex');
        $('html').removeClass('no-scroll'); 
    }

})

$(document).on('click', '[data-action="open-drawer"]', function(){
    //$('#sidebar-cart').attr('aria-hidden', 'false');
    $('.PageOverlay').addClass('is-visible');    
    $('#sidebar-cart').attr('tabindex', '-1');
    $('html').addClass('no-scroll');    
})


if( window.location.pathname == '/account/register' ){
    var today = new Date();
    var currentMonth = today.getMonth();
    var currentYear = today.getFullYear();
    var selectYear = document.getElementById("year");
    var selectMonth = document.getElementById("month");
    var monthDefault = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio","Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
    var dayDefault = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
    var months = monthDefault;
    var days = dayDefault;
    var monthAndYear = document.getElementById("monthAndYear");
    var dataHead;
    
    // Métodos de:
    // Abrir caléndário (criando seus elementos)
    // Cria quantidade de dias no mês
    // Cria um ano mínimo e máximo para o calendário
    // Preencher o background das células vázias da tabela calendário
    var calendar = {
        showCalendar: function(month, year) {
            let firstDay = ( new Date( year, month ) ).getDay();    
            let tbl = document.getElementById("calendar-body");
            
            tbl.innerHTML = "";
            
            monthAndYear.innerHTML = months[month] + " " + year;
            selectYear.value = year;
            selectMonth.value = month;
        
            // criando todas as células
            let date = 1;
            for ( let i = 0; i < 6; i++ ) {        
                let row = document.createElement("tr");
                
                for ( let j = 0; j < 7; j++ ) {
                    if ( i === 0 && j < firstDay ) {
                        cell = document.createElement( "td" );
                        cellText = document.createTextNode("");
                        cell.appendChild(cellText);
                        row.appendChild(cell);
                    } else if (date > calendar.daysInMonth(month, year)) {
                        break;
                    } else {
                        cell = document.createElement("td");
                        cell.setAttribute("data-date", date);
                        cell.setAttribute("data-month", month + 1);
                        cell.setAttribute("data-year", year);
                        cell.setAttribute("data-month_name", months[month]);
                        cell.className = "date-picker";
                        cell.innerHTML = "<span>" + date + "</span>";
        
                        // Ao abrrr o calendário, aponta para o dia vigente
                        // if ( date === today.getDate() && year === today.getFullYear() && month === today.getMonth() ) {
                        //     cell.className = "date-picker selected";
                        // }
        
                        if($('.calendar-custom').hasClass('is--active')){                    
                            $(`[data-date=${ $('.selectDay').val() }]`).addClass('selected')
                        } else{                    
                            setTimeout(()=>{
                                $(`[data-date=${ $('.selectDay').val() }]`).addClass('selected')
                            }, 800)
                        }
        
                        row.appendChild(cell);
                        date++;
                    }
                }
        
                tbl.appendChild(row);
            }
            // criando select de dias
            for ( let i = 1; i < date; i++ ) {
                $('.selectDay').append(`<option data-value="${ i }"> ${ i } </option>`)
        
            }
        },    
        daysInMonth: function(iMonth, iYear) {
            return 32 - new Date(iYear, iMonth, 32).getDate();
        },
        generate_year_range: function(start, end) {
            let years = "";
            for (var year = start; year <= end; year++) {
                years += "<option value='" + year + "'>" + year + "</option>";
            }
            return years;
        },
        tblColorCellWhite: function(){
            $('#calendar-body tr').find('td').each(function(){
                if(  $(this).children().length == 0 ){
                    $(this).css('background', '#e2e2e2')
                } else {
                    $(this).css('cursor', 'pointer')
                }
            })        
        }
    }
    
    // cria o cabeçalho do calendário ex: (dom, seg...)
    for (dhead in days) {
        dataHead += "<th data-days='" + days[dhead] + "'>" + days[dhead] + "</th>";
    }
    
    // insere o cabeçalho no html
    $("#thead-month").find('tr').html(dataHead);
    
    var createYear = calendar.generate_year_range(1910, 2050);
    
    // insere os anos que foram gerados no html
    $('#year').html(createYear);
    
    calendar.showCalendar(currentMonth, currentYear);
    
    $(document).on('change', '#month, #year', function(){
        currentYear = parseInt(selectYear.value);
        currentMonth = parseInt(selectMonth.value);
        calendar.showCalendar(currentMonth, currentYear);
    })
    
    $(document).on('click', '.date-picker', function(){
        $('[data-date]').each(function(){
            $(this).removeClass('selected')
        })
    
        $(this).addClass('selected');
    
        let day = $(this).data().date <= 9 ? '0' + $(this).data().date : $(this).data().date;
        let month = $(this).data().month <= 9 ? '0' + $(this).data().month : $(this).data().month;
        let year = $(this).data().year <= 9 ? '0' + $(this).data().year : $(this).data().year ;
    
        $(`[data-value="${Number(day)}"]`).attr('selected', 'selected');
    
        $('.field-birthday-hide').val(`${year}-${month}-${day}`).trigger('input'); 
    
        setTimeout(()=>{
            $(".field-birthday").val($(".field-birthday-hide").val().split('-').reverse().join('/'))
        },200)
    })
    
    $(document).on('change', '.calendar-custom-footer select', function(){
        calendar.tblColorCellWhite()
    
        let day, month, year; 
    
        day = $('.selectDay').val() <= 9 ? '0' + $('.selectDay').val() : $('.selectDay').val();
        month = (Number($('#month').val())+1) <= 9 ? '0' + (Number($('#month').val())+1) : Number($('#month').val())+1;
        year = $('#year').val();
    
        $('.field-birthday-hide').val(`${year}-${month}-${day}`).trigger('input');
    
        setTimeout(()=>{
            $(".field-birthday").val($(".field-birthday-hide").val().split('-').reverse().join('/'))
        },200)
    
        let fieldBirthday = $('.field-birthday-hide').val().split('-').reverse();
    
         $('.date-picker').each(function(){
            if( $(this).hasClass('selected') ){
                day = $(this).data().date <= 9 ? '0' + $(this).data().date : $(this).data().date;
                fieldBirthday[0] = day
            }
        })
    
        switch ($(this).attr('id')) {
            case 'month':            
                month = (Number($(this).val())+1) <= 9 ? '0' + (Number($(this).val()) +1) : Number($(this).val()) +1;
                fieldBirthday[1] = month
                break;
    
            case 'year':            
                year = $(this).val() 
                fieldBirthday[2] = year
                break;
        
            default:
                break;
        }
    
        $('.field-birthday-hide').val(`${fieldBirthday.reverse().join('-')}`).trigger('input');
    
        setTimeout(()=>{
            $(".field-birthday").val($(".field-birthday-hide").val().split('-').reverse().join('/'))
        },200)
    })
    
    $(document).on('click', '.field-birthday', function(){
        $('.calendar-custom').toggleClass('hide')
        $('.calendar-custom').toggleClass('is--active')
        $('html').addClass('no-scroll')
    
        if(  $('.calendar-custom').hasClass('is--active') ){
            setTimeout(()=>{
                let day = $('.selectDay').val() <= 9 ? '0' + $('.selectDay').val() : $('.selectDay').val();
                let month = $('#month').val()+1 ;
                let year = $('#year').val();
    
                $('.field-birthday-hide').val(`${year}-${month}-${day}`).trigger('input')
    
                setTimeout(()=>{
                    $(".field-birthday").val($(".field-birthday-hide").val().split('-').reverse().join('/'))
                },200)        
            },800)
        }
    
    })
    
    $(document).on('click', function(e){       
        if( e.target.classList.contains('is--active') ) {
            let day = $('.selectDay').val() <= 9 ? '0' + $('.selectDay').val() : $('.selectDay').val();
            let month = (Number($('#month').val())+1) <= 9 ? '0' + (Number($('#month').val())+1) : Number($('#month').val())+1; ;
            let year = $('#year').val();
    
            $('.field-birthday-hide').val(`${year}-${month}-${day}`).trigger('input')
    
            setTimeout(()=>{
                $(".field-birthday").val($(".field-birthday-hide").val().split('-').reverse().join('/'))
            },200)
    
    
            $('.calendar-custom').toggleClass('hide')
            $('.calendar-custom').toggleClass('is--active')
            $('html').toggleClass('no-scroll')
    
        }            
    })
    
    $(document).on('change', '.selectDay', function(){
        calendar.tblColorCellWhite()
    
        let day;
    
        $( ".selectDay option:selected" ).each(function() {
         day = $(this).val();
        });
    
        if(  $(this).find('[data-value]').attr('selected') ){
        }
    
        $('[data-date]').each(function(){
            $(this).removeClass('selected');
        })
    
        $(`[data-date="${day}"]`).addClass('selected');
    
        if(  day <= 9 ){
            day = '0' + day
        }    
    
        $('.field-birthday-hide').val(`${$('#year').val()}-${Number($('#month').val())+1}-${day}`).trigger('input')
       
        setTimeout(()=>{
            $(".field-birthday").val($(".field-birthday-hide").val().split('-').reverse().join('/'))
        },200)    
    })
    
    $(document).on("click", ".calendar-custom__close", function () {
        $('.calendar-custom').addClass('hide')
        $('.calendar-custom').removeClass('is--active')
        $('html').removeClass('no-scroll')
    });
    
    calendar.tblColorCellWhite();
    
    window.onload = ()=>{
        $(".field-birthday").val($(".field-birthday-hide").val().split('-').reverse().join('/'))
    }
}

const calculateProductTax = (price) => {
    if($('.product-tax')[0] && $('[data-current-product-price]')[0] && price > 0){
        const percent_tax = Number($('.product-tax').attr('data-tax-percent'));
        const plus_tax = Number($('.product-tax').attr('data-tax-plus')) * 100;
        const product_price = parseInt($('[data-current-product-price]').attr('data-current-product-price'));
        const percent_of_price = product_price * (percent_tax / 100);
        const final_tax = percent_of_price + plus_tax;
        const price_without_tax = product_price - final_tax;
        $('.product-tax').html(`(${window.customFormatMoney(price_without_tax, window.theme.moneyFormat)} + ${window.customFormatMoney(final_tax, window.theme.moneyFormat)} TAXAS)`);
    }
}

$(function(){
    if($('.product-tax')[0]){
        calculateProductTax(2000);
    }
});

//! Métodos para a funcionalidade do calendário custozado do input tipo date_________________|  Final |